import { Button } from "shared/components/Button";
import { CheckList } from "shared/components/CheckList";
import { SMALL, TYPE_LINK, MEDIUM } from "shared/utils/constants";
import { Spacing } from "shared/components/Spacing";
import { SrcSet } from "shared/components/SrcSet";
import cx from "classnames";
import styles from "./HomeLandingPageSection.module.css";

export const HomeLandingPageSection = ({
  title,
  intro,
  image,
  linkLabel,
  page,
  reversed,
}) => (
  <Spacing size={MEDIUM}>
    <div className={cx(styles.container, { [styles.reversed]: reversed })}>
      <div className={styles.content}>
        {title && <h3 className={styles.title}>{title}</h3>}
        {intro && <p className={styles.intro}>{intro}</p>}
        {page?.heroList && <CheckList items={page?.heroList} size={SMALL} />}

        {page && (
          <div className={styles.buttonWrapper}>
            <Button type={TYPE_LINK} href={page?.slug?.current}>
              {linkLabel}
            </Button>
          </div>
        )}
      </div>
      <div className={styles.imageWrapper}>
        {image && (
          <SrcSet
            alt={image.alt}
            sizes={[
              { minWidth: 900, width: 500 },
              { minWidth: 768, width: 440 },
              { minWidth: 1, width: 400 },
            ]}
            src={image.url}
          />
        )}
      </div>
    </div>
  </Spacing>
);
